const pixelsCategories = ["TARGETING"];

export { pixelsCategories };